import { GET_ORDERS, UPDATE_ORDER, SET_ORDER_FILTER, EXPORT_ORDERS_REPORT, OPEN_CUSTOM_MODAL, VERIFY_VOUCHER, CLEAR_VOUCHER,GET_HOLIDAYS } from '../actions/types';

const INITIAL_STATE = {
    order_list: [],
    upload_status: 200,
    filter: 'All',
    voucher_discount: null,
    customModal: false,
    exportModal: false,
    list: [],
    status: 'ok',
}

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case GET_ORDERS:
            return {
                ...state,
                order_list: action.payload
            }

        case SET_ORDER_FILTER:
            return {
                ...state,
                filter: action.payload
            }

        case UPDATE_ORDER:
            let order_index = state.order_list.findIndex((n) => n._id === action.payload._id);
            return {
                ...state,
                order_list: state.order_list.map((order, index) => {
                    if (index === order_index) {
                        return Object.assign({}, order, action.payload)
                    }
                    return order
                })
            }

        case EXPORT_ORDERS_REPORT:
            return {
                ...state,
                exportModal: action.payload
            }

        case OPEN_CUSTOM_MODAL:
            return {
                ...state,
                customModal: action.payload
            }

        case VERIFY_VOUCHER:
            return {
                ...state,
                voucher_discount: action.payload
            }

        case CLEAR_VOUCHER:
            return {
                ...state,
                voucher_discount: null
            }
        case GET_HOLIDAYS:
            return {
                ...state,
                status: 'ok',
                list: action.payload
            }

        default:
            return state;
    }
};
